import { Navigate, Outlet } from "react-router";
import { useUser } from "../../hooks/useUser";
import { LoadingSpinner } from "../../bits/loading";

const ProtectedAdminRoute = () => {
  const { user, isLoading } = useUser();

  if (isLoading) {
    return <LoadingSpinner />;
  }

  if (!user?.admin) {
    return <Navigate to="/" replace />;
  }

  return <Outlet />;
};

export default ProtectedAdminRoute;
